const getPosts = async (page, postType = 'posts', taxonomy, term) => {
    const endpoint = `${wpstatsHelper.site_url}/wp-json/wp/v2/${postType}?page=${page}&per_page=${wpstatsHelper.posts_per_page}`;

    const queryParams = new URLSearchParams();

    if (taxonomy && term) {
        queryParams.append(taxonomy, term); // e.g., `categories=5` or `tags=3`
    }

    try {
        const response = await fetch(`${endpoint}&${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': wpstatsHelper.nonce, // For authenticated requests if required
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching ${postType} posts: ${response.status}`);
        }

        const data = await response.json();
        return data; // Returns an array of posts
    } catch (error) {
        console.error(error);
        throw error;
    }
};

const renderPosts = (posts, postType, container) => {
    posts.forEach((post) => {
        let postHTML = '';

        if (postType === 'release') {
            // HTML structure for "release" post type
            const readMoreLabel = `
                <span>Full ${post.title.rendered} changelog</span>
                <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" stroke="#6759FF" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.0249 4.94165L17.0832 9.99998L12.0249 15.0583" stroke-width="2" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.91675 10H16.9417" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>
                </span>
            `;

            postHTML = `
                <article id="release-${post.id}" class="c-release c-release--archive s-release">
                    <header class="c-release__header">
                        <h2 class="c-release__title">
                            <a href="${post.link}" rel="bookmark">${post.title.rendered}</a>
                        </h2>
                        <time class="c-release__date">${post.formatted_date || ''}</time>
                    </header>
                    <main class="c-release__content">
                        <div class="entry-meta">
                            <div class="c-release__excerpt">
                                <p>${post.excerpt.replace(/<[^>]+>/g, '')}</p>
                                <a href="${post.link}" class="more-link">${readMoreLabel}</a>
                            </div>
                        </div>
                    </main>
                </article>
            `;
        } else if (postType === 'resources') {
            // HTML structure for "resources" post type
            postHTML = `
                <article class="c-document">
                    <div class="c-document__content">
                        <h2 class="c-document__title">${post.title.rendered}</h2>
                        <div class="c-document__desc">
                            <p>${post.excerpt.replace(/<[^>]+>/g, '')}</p>
                        </div>
                    </div>
                    <a aria-label="${post.title.rendered}" href="${post.link}" class="c-document__link"></a>
                </article>
            `;
        } else {
            const categories = post.categories_details?.map(cat => `
                        <span class="o-links--category"><a href="${cat.url}">${cat.name}</a></span>
                    `).join(', ') || '';

            postHTML = `
                        <article id="post-${post.id}" class="c-post--archive">
                            <div class="c-post__content">
                                <div class="entry-meta">
                                    <div class="c-post__info">${categories}</div>
                                    <h2 class="c-post__title">
                                        <a href="${post.link}" rel="bookmark">${post.title.rendered}</a>
                                    </h2>
                                    <div class="c-post__excerpt">
                                        <p>${post.excerpt.rendered.replace(/<[^>]+>/g, '').substring(0, 100)}</p>
                                    </div>
                                    <div class="c-post__meta">
                                    <div class="c-post-meta">
                                        <div class="c-post-meta__author">
                                        <a href="${post.author_details?.url}" class="url fn n">
                                            <span class="author-avatar">
                                                <img width="24" height="24" src="${post.author_details?.avatar || ''}" alt="${post.author_details?.name || ''}" class="avatar avatar-24 photo">
                                            </span>
                                            <span>${post.author_details?.name || 'Unknown Author'}</span>
                                        </a>
                                        </div>
                                        <span class="o-sep o-sep--circle"></span>
                                        <span class="c-post-meta__date">${post.formatted_date || ''}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="c-post__thumbnail">
                                <a class="post-thumbnail" href="${post.link}">
                                    <img src="${post.featured_image_src || ''}" alt="${post.title.rendered}">
                                </a>
                            </div>
                        </article>
                    `;
        }

        // Append the generated HTML to the container
        container.insertAdjacentHTML('beforeend', postHTML);
    });
};

export { getPosts, renderPosts };
